import { Navigate, Outlet } from 'react-router-dom';
import { useAccess } from '../hooks/useAccess';
import { useApprovalModuleAccess } from '../hooks/useApprovalModuleAccess';

/** Route guard: roles.view + at least one approval module allowed by admin. */
export function RequireApprovalFlows() {
  const { can } = useAccess();
  const { anyEnabled, isLoading } = useApprovalModuleAccess();
  if (isLoading) return <Outlet />;
  if (!can('roles.view') || !anyEnabled) {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
}
